// extracted by mini-css-extract-plugin
export default {"carregador":"Carregador_carregador__qd2DI","icone":"Carregador_icone__SrCWh","small":"Carregador_small__m-WiC"};